<template>
  <div>
    <v-menu
      ref="menu1"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          :label="label || 'Date'"
          :hint="showHint ? 'MM/DD/YYYY format' : ''"
          persistent-hint
          :prepend-icon="showIcon ? 'mdi-calendar' : ''"
          v-bind="attrs"
          @blur="date = parseDate(dateFormatted)"
          v-on="on"
          :outlined="outlined"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        :max="max"
        @input="menu1 = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    showHint: {
      type: Boolean,
      required: false,
      default: false,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    max: {
      type: String,
      required: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: vm => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    ),
    menu1: false,
  }),
  mounted() {
    if (this.value) {
      this.date = moment(this.value).format("YYYY-MM-DD");
    } else {
      this.$emit("input", this.date);
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.$emit("input", this.date);
    },
    value: function(newVal, oldVal) {
      console.log("Date value changed from " + oldVal + " to " + newVal);
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style></style>
